$(() => {
	// Loop through any child blocks and wrap them in a tab pane.
	$('.tabbed-content').each((i, el) => {
		const $module = $(el);
		const $tabs = $module.find('.tabbed-content__tabs');
		const $content = $module.find('.tabbed-content__content');

		$content.children().each((i, el) => {
			const $planSlider = $(el);
			const $tab = $tabs.find('.tab-btn').eq(i);
			const tabID = $tab.attr('aria-controls');
			const tabName = $tab.parent().data('tab-name');
			const tabHtml = $tab.html();
			const uniqid = Math.random().toString(36).substring(2, 15);
			const plusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path stroke="#00c2f3" d="M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5Z"/><path fill="#00c2f3" d="M7.188 12.825a.687.687 0 0 1-.688-.688v-.274c0-.38.308-.688.688-.688h9.625c.38 0 .687.308.687.688v.274c0 .38-.308.688-.688.688H7.188Z"/><path fill="#00c2f3" d="M11.175 7.188c0-.38.308-.688.688-.688h.274c.38 0 .688.308.688.688v9.625c0 .38-.308.687-.688.687h-.274a.687.687 0 0 1-.688-.688V7.188Z" class="pipe"/></svg>`;

			// Wrap the inner blocks in tab panes for desktop tabs.
			$planSlider.wrapAll(`<div class="tab-pane fade ${i === 0 ? 'show active' : ''}" data-tab-name="${tabName}" id="${tabID}" role="tabpanel" aria-labelledby="${$tab.attr('id')}" tabindex="0"><div id="accordion-${uniqid}" class="accordion-collapse collapse"><div class="accordion-tab-body"></div></div></div>`)

			// Add accordion toggle button for mobile (inside tab pane, at top).
			$(`#${tabID}`).prepend(`<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-${uniqid}" aria-expanded="true" aria-controls="accordion-${uniqid}">${tabHtml+plusIcon}</button>`);
		});
	});

	// Refresh any slick sliders when a tab is shown.
	$('.tab-btn').on('shown.bs.tab', e => {
		const $target = $(e.target);
		const $tabPane = $target.data('bs-target');
		const $slider = $($tabPane).find('.card-slider');
		if ($slider.length) {
			$slider.slick('setPosition');
		}
	})
})
